import React, { FC } from 'react'

import { IconNumber3Props } from './IconNumber3.types'
import * as Styled from './styles/IconNumber3.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNumber3: FC<IconNumber3Props> = ({
  size = nonThemeableRules.defaultSize as number as IconNumber3Props['size'],
  isResponsive = false,
}: IconNumber3Props) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.555 15h10.773l-6.95 6.953.02.024a7.65 7.65 0 0 1 1.368-.125c3.468 0 6.28 2.41 6.28 5.382 0 2.97-2.812 5.75-6.28 5.75a5.877 5.877 0 0 1-5.203-2.87'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M43 24.059c-.031 10.48-8.52 18.968-19 19-10.48-.032-18.969-8.52-19-19 .031-10.48 8.52-18.973 19-19h19v19Z'
          stroke='#fff'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNumber3
